/**
 * Dealer Manage : 经销商管理
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/iam/v1',
  items: [
    // 手动刷新表IAM权限
    {
      key: 'updateToolPermissionFresh',
      url: '/tool/permission/fresh',
      method: 'POST',
      type: 'query',
    },
  ],
};

export default {
  ...generate(config),
};
